import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";

import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;

const Cpc = ({
  channel_campaign_group,
  channel_campaign_id,
  channel_id,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/channels/${channel_id}/channel_campaigns/${channel_campaign_id}/channel_campaign_groups/${channel_campaign_group?.id}/update_sales_period_cpc`,
    onSuccess: refetch,
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{
        title: "Stawki CPC dla okresów sprzedaży",
        icon: "info",
      }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="row m-b-20">
          <div className="box-6"></div>
        </div>
        <div className="row">
          <div className="box-6">
            <Field
              name="sales_period_min_cpc_percent"
              label="Minimalna stawka CPC (%)"
              component={InputField}
              type="number"
              postfix="%"
            />
            <p className="default-text-small">
              Minimalna stawka CPC:{" "}
              <strong>{channel_campaign_group.sales_period_min_cpc}</strong>
            </p>
          </div>
          <div className="box-6">
            <Field
              name="sales_period_max_cpc_percent"
              label="Maksymalna stawka CPC (%)"
              component={InputField}
              type="number"
              postfix="%"
            />
            <p className="default-text-small">
              Maksymalna stawka CPC:{" "}
              <strong>
                {channel_campaign_group.sales_period_max_cpc || "-"}
              </strong>
            </p>
          </div>
        </div>
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};

  if (
    Number(values.sales_period_min_cpc_percent) < 0 ||
    Number(values.sales_period_min_cpc_percent) > 100
  ) {
    errors.sales_period_min_cpc_percent =
      "Wartość powinna być z przedziału 1-100";
  }

  if (
    Number(values.sales_period_max_cpc_percent) < 0 ||
    Number(values.sales_period_max_cpc_percent) > 100
  ) {
    errors.sales_period_max_cpc_percent =
      "Wartość powinna być z przedziału 1-100";
  }
  return errors;
};

export default reduxForm({
  form: "update-channel-campaign-group-cpc",
  enableReinitialize: true,
  validate,
})(Cpc);
